import * as _ from "lodash";
import { ReportsCollection } from "../../../collections/Reports";
import { UserCollection } from "../../../collections/Users";
import { BaseInternalView } from "../../_BaseViews";
import { BaseEditViewOptions } from "./_BaseEditView";
import { EditPermissionsView } from "./EditPermissionsView";
import { EditPreviewView } from "./EditPreviewView";
import { EditSettingsView } from "./EditSettingsView";

export class EditReportsView extends BaseInternalView {

    public options: BaseEditViewOptions;

    private orgId: number;
    private reportId: number;
    private category: string;

    private userCollection: UserCollection;
    private reportsCollection: ReportsCollection;

    private collectionLoaded = false;
    private view: any = null;

    private template = _.template(require('../../../templates/reports/editReports/editReports.html'));

    constructor(options: BaseEditViewOptions) {
        super(<any> _.extend(options, {
            events: {}
        }));
    }

    loadCollections () {
        this.userCollection = new UserCollection([], {organizationId: this.orgId});
        this.reportsCollection = new ReportsCollection();

        var outerDeferred = $.Deferred();
        $.when(
            this.reportsCollection.fetch(),
            this.userCollection.fetch()
        ).done((collection) => {

            this.collectionLoaded = true;
            outerDeferred.resolve();
        });

        return outerDeferred;
    }

    render () {
        if(!this.collectionLoaded) {
            $.when(this.loadCollections()).done(() => {
                this.render();
            });
        }

        if(this.collectionLoaded) {
            this.renderSubViews();
        } else {
            // We're not loaded yet, so show spinner
            this.$el.html(this.template({
                collectionLoaded: this.collectionLoaded
            }));
        }

        return this;
    }

    show (orgId, reportId, reportsEditCategory) {
        // Get org and report ids from the router
        this.orgId = orgId;
        this.reportId = reportId;
        this.category = reportsEditCategory;
        this.render();
    }

    renderSubViews () {
        if (this.view) this.view.remove();

        var category = this.category;
        var report = this.reportsCollection.findWhere({
            id: this.reportId
        });

        // Save visit to localStorage
        this.saveReportVisit(this.orgId, this.reportId);

        // If our view has a category, render the appropriate subview
        if (category === 'settings' || category === 'edit') {
            // This is the view we see at '/:orgId/:reportId/edit/settings'
            this.view = new EditSettingsView (_.extend({}, this.options,{
                reportsCollection: this.reportsCollection,
                userCollection: this.userCollection,
                report: report,
                orgId: this.orgId,
                category: 'settings',
            }));
        } else if (category === 'preview') {
            // This is the view we see at '/:orgId/:reportId/edit/preview'
            this.view = new EditPreviewView (_.extend({}, this.options,{
                report: report,
                reportsCollection: this.reportsCollection,
                orgId: this.orgId,
                category: category,
            }));
        } else if (category === 'permissions') {
            // This is the view we see at '/:orgId/:reportId/edit/permissions'
            this.view = new EditPermissionsView (_.extend({}, this.options,{
                report: report,
                reportsCollection: this.reportsCollection,
                orgId: this.orgId,
                category: category,
            }));
        } else {
            // If any non-existent category is entered, redirect us to the main reports view
            return window.location.href = '/#/reports/' + this.orgId;
        }

        this.$el.empty().append(this.view.render().el);
    }

    /**
     * Saves the current report visit to localStorage.
     * Keeps a list of the 5 most recently visited reports, each with org ID, report ID, name, and timestamp.
     *
     * @param {string} orgId - The organization ID the report belongs to.
     * @param {string} reportId - The ID of the report being visited.
     */
    saveReportVisit(orgId, reportId) {
        const MAX_ENTRIES = 5;
        const STORAGE_KEY = "recentReports";
      
        // Load current visits
        let visits = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      
        // Check if the entry already exists
        const alreadyExists = visits.some(
          (item) => item.reportId === reportId && item.orgId === orgId
        );
      
        if (alreadyExists) return; // Don't add again
      
        const reportName = this.getReportName();
        const visitedAt = new Date().toISOString();
      
        // Add new visit to top
        visits.unshift({
          userId: this.options.currentUser.get("id"),
          id: reportId,
          reportId: reportId,
          orgId: orgId,
          name: reportName,
          visitedAt: visitedAt,
        });
      
        // Keep only the most recent 5
        if (visits.length > MAX_ENTRIES) {
          visits = visits.slice(0, MAX_ENTRIES);
        }
      
        // Save back to localStorage
        localStorage.setItem(STORAGE_KEY, JSON.stringify(visits));
      }      

    /**
     * Retrieves the name of the currently selected report.
     * Customize this based on how the report name is stored/fetched.
     *
     * @returns {string} - The name of the report, or a fallback if unavailable.
     */
    getReportName() {
        const reportModel = this.reportsCollection.findWhere({ id: this.reportId });
        return reportModel ? reportModel.get("name") : "Unknown Report";
    }

    remove() {
        this.view.remove();
        return super.remove();
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/views/reports/editReports/EditReportsView.ts